/* Word-split clip reveal for headings + fade-up for eyebrows/paragraphs/photos */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// Elements already visible on page load don't need an entrance animation
function aboveFold(el) {
  return el.getBoundingClientRect().top < window.innerHeight;
}

export function headingReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const heroSection = document.querySelector('.sc-hero, .hero');

  // Eyebrows + paragraphs outside the home hero
  document.querySelectorAll('main .eyebrow, main p').forEach(el => {
    if (heroSection && heroSection.contains(el)) return;
    if (aboveFold(el)) return;
    gsap.from(el, {
      y: 16,
      opacity: 0,
      duration: 0.6,
      ease: 'expo.out',
      scrollTrigger: { trigger: el, start: 'top 88%', once: true },
    });
  });

  // Photos — fade + scale up
  document.querySelectorAll('.photo-img, .wp-block-image').forEach(el => {
    if (aboveFold(el)) return;
    gsap.from(el, {
      scale: 0.95,
      opacity: 0,
      duration: 0.9,
      ease: 'expo.out',
      scrollTrigger: { trigger: el, start: 'top 88%', once: true },
    });
  });

  // Exclude the home hero h1 which has its own init + timeline in scroll.js
  const heroH1 = document.querySelector('.sc-hero h1, .hero h1');
  const headings = [...document.querySelectorAll('main h1, main h2, main h3, main h4, main h5')].filter(
    h => !heroH1 || !heroH1.contains(h) && h !== heroH1
  );

  headings.forEach(h => {
    const nodes = [...h.childNodes];
    h.innerHTML = '';

    nodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            h.appendChild(document.createTextNode(part));
          } else {
            const line = document.createElement('span');
            line.className = 'line';
            const inner = document.createElement('span');
            inner.textContent = part;
            line.appendChild(inner);
            h.appendChild(line);
          }
        });
      } else if (node.nodeName === 'BR') {
        h.appendChild(document.createElement('br'));
      } else {
        const line = document.createElement('span');
        line.className = 'line';
        const inner = document.createElement('span');
        inner.appendChild(node.cloneNode(true));
        line.appendChild(inner);
        h.appendChild(line);
      }
    });

    const spans = h.querySelectorAll('.line > span');
    if (!spans.length) return;

    // Above-fold headings: still split the DOM but skip the animation
    if (aboveFold(h)) return;

    gsap.from(spans, {
      yPercent: 110,
      duration: 0.8,
      stagger: 0.04,
      ease: 'expo.out',
      scrollTrigger: { trigger: h, start: 'top 88%', once: true },
    });
  });
}
